// Arquivo: PdfLayout.tsx
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { ReactNode } from "react";

const styles = StyleSheet.create({
  page: {
    padding: "40px",
    fontFamily: "Helvetica",
    fontSize: 9,
    lineHeight: 1.6,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 40,
  },
  logo: {
    width: 50,
    height: 50,
    marginRight: 15,
  },
  headerTitle: {
    fontSize: 18,
    fontFamily: "Helvetica-Bold",
    color: "#333",
  },
  footer: {
    position: "absolute",
    bottom: 25,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 10,
    color: "grey",
  },
});

type Props = {
  title: string;
  children: ReactNode;
};

export function PdfLayout({ title, children }: Props) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header} fixed>
          <Image
            style={styles.logo}
            src="https://static.wixstatic.com/media/df06c6_6d661cb9805a4bd0b404cddda3f83de8~mv2.png/v1/fill/w_180,h_180,lg_1,usm_0.66_1.00_0.01/df06c6_6d661cb9805a4bd0b404cddda3f83de8~mv2.png"
          />
          <Text style={styles.headerTitle}>{title}</Text>
        </View>
        {children}
        <Text style={styles.footer} fixed />
      </Page>
    </Document>
  );
}
